import React from "react";
import StaticConnectionsSection from "./StaticConnectionsSection";
import FilteredConnectionsSection from "./FilteredConnectionsSection";
import {
    NetworkType,
    PriorityType,
    UrgencyType,
    ConnectionHubPage,
    ConnectionsMeta,
} from "../../gql/types";
import HomeCard from "../home/card/HomeCard";

interface ConnectionsHubPageProps {
    page: ConnectionHubPage;
    isSelectMode: boolean;
    selectedIds: Set<string>;
    onToggle: (connectionIds: string[]) => void;
}

const ConnectionsHubPage: React.FC<ConnectionsHubPageProps> = ({
    page,
    isSelectMode,
    selectedIds,
    onToggle,
}) => {
    let nonEmptySectionRendered = false;

    return (
        <HomeCard>
            {page.sections.map((section, idx) => {
                const openSection = !nonEmptySectionRendered && (section.connections.length > 0 || section.message !== null);
                if (!nonEmptySectionRendered) {
                    nonEmptySectionRendered = openSection && section.connections.length > 0;
                }

                return (
                    <StaticConnectionsSection
                        key={section.id}
                        title={section.title}
                        networkType={section.networkType ?? NetworkType.Direct}
                        priorityType={section.priorityType ?? PriorityType.Low}
                        urgencyType={section.urgencyType ?? UrgencyType.Low}
                        message={section.message ?? null}
                        connections={section.connections}
                        count={section.count}
                        isSelectMode={isSelectMode}
                        selectedIds={selectedIds}
                        onToggle={onToggle}
                        openSection={openSection}
                    />
                );
            })}
            {!nonEmptySectionRendered &&
                page.connectionsMeta.length > 0 &&
                <FilteredConnectionsSection
                    key={0}
                    meta={page.connectionsMeta[0]}
                    isSelectMode={isSelectMode}
                    selectedIds={selectedIds}
                    onToggle={onToggle}
                    openSection={true}
                />
            }
            {page.connectionsMeta.map((meta: ConnectionsMeta, idx: number) => {
                // Skip first if already rendered
                if (!nonEmptySectionRendered && idx === 0) return null;

                return (
                    <FilteredConnectionsSection
                        key={idx}
                        meta={meta}
                        isSelectMode={isSelectMode}
                        selectedIds={selectedIds}
                        onToggle={onToggle}
                    />
                );
            })}
        </HomeCard>
    );
};

export default ConnectionsHubPage;
